export default __webpack_public_path__ + "static/media/json-icon.4fe150e2.svg";